<template>
    <div>
      <link v-if="typeof builder !== 'undefined' && typeof builder.venue !== 'undefined' && builder.venue.id === 264" href="assets/css/venue-264.css" rel="stylesheet" type="text/css"/>
        <!--<div class="container-fluid no-padding masthead" id="homepage-masthead" v-bind:style="{ background: 'url('+ (venue ? venue.image_url : $root.locale.misc.FallbackHeaderImage ) +') center 70% / cover no-repeat, url('+$root.locale.misc.FallbackHeaderImage+') center 17% / cover no-repeat' }"></div>-->

        <div class="container-fluid title-bar" >
          <div class="vertical">
            <div class="container">
                <div class="row">
                    <transition name="fade">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-if="$root.hasOwnProperty('headers')" :class="{ 'no-breadcrumbs': !$root.headers.hasOwnProperty('breadcrumbs') || ($root.headers.hasOwnProperty('breadcrumbs') && $root.headers.breadcrumbs.length === 0) && !venue }">
                            <a v-if="$root.headers.hasOwnProperty('navigate') && $root.headers.navigate != null && !$root.headers.navigate.back" class="fa fa-chevron-left breadcrumbs-icon" @click="back"></a>
                            <span class="location">
                                <a v-if="$root.headers.hasOwnProperty('breadcrumbs') && venue" class="breadcrumb-link" @click="changeVenue">{{ venue.name+ ' (' + venue.town + ') ' + ($root.headers.breadcrumbs.length > 0 ? ' /&nbsp;' : ' ') }}</a>
                                <router-link v-if="$root.headers.hasOwnProperty('breadcrumbs') && venue" class="breadcrumb-link" v-for="(breadcrumb, key) in $root.headers.breadcrumbs" :to="{ name: breadcrumb.to.name, query: (Object.isEmpty(breadcrumb.to.query) || !breadcrumb.to.query? {a:'1'} : Object.filter(breadcrumb.to.query, function (obj) { return obj == undefined || obj == null })) }" v-html="breadcrumb.title+(key == $root.headers.breadcrumbs.length-1 ? ' ' : ' /&nbsp;')" v-bind:key="key"></router-link>
                            </span>
                            <h1 v-if="$root.headers.hasOwnProperty('title')" v-html="($root.headers.title ? $root.headers.title : (venue != null ? venue.name : '' ) )"></h1>

                            <div class="switch-package-container">
                                <transition name="fade">
                                    <a @click="switcher" v-if="show_switch_option == 'weeks'" v-html="this.$root.locale.booking.packages.text_switch_to_full_weeks"></a>
                                    <a @click="switcher" v-else-if="show_switch_option == 'days'" v-html="this.$root.locale.booking.packages.text_switch_to_individual_days"></a>
                                     <!-- <a href="https://www.kingscamps.org/booking-request" v-else-if="show_switch_option == 'days'" v-html="this.$root.locale.booking.packages.text_switch_to_individual_days"></a> -->
                                </transition>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
          </div>
        </div>
    </div>

</template>

<script>
    export default {
        data () {
            return {
                page: this.$route.name,
                builder: undefined,
                venue: null,
                image: "",
                show_switch_option: false
            }
        },
        computed: {
            locale: function () {
                return this.$root.locale.global;
            }
        },
        methods: {
            back: function () {
                if(this.$route.name != 'booking.packages.customize')
                    this.$router.push({ name: this.$root.headers.navigate.name, query: this.$root.headers.navigate.query, params: this.$root.headers.navigate.params });
                else
                    history.go(-1);
            },
            switcher: function () {
                //{ name: 'booking.weeks', query: { age: (this.$route.query.hasOwnProperty('age') ? this.$route.query.age : null), min_age: (this.$route.query.hasOwnProperty('min_age') ? this.$route.query.min_age : null) } }

                var individual_days = this.show_switch_option == 'days';
                this.show_switch_option = false;

                // Change min_age to 15 and age to 17 if current min_age is 5 and age is 14 (switching from weekly MA to individual days should switch the age range from 5-14 to 15-17, and switching back should switch it back to 5-14)
                if (
                    this.$route.query.hasOwnProperty('min_age') &&
                    this.$route.query.hasOwnProperty('age')
                ) {
                    // If current is 5-14, switch to 15-17
                    if (this.$route.query.min_age == 5 && this.$route.query.age == 14) {
                        this.$router.push({
                            name: 'booking.weeks',
                            query: { age: 17, min_age: 15 }
                        });
                        return;
                    }
                    // If current is 15-17, switch to 5-14 and add days: true
                    if (this.$route.query.age == 17) {
                        this.$router.push({
                            name: 'booking.weeks',
                            query: { age: 14, min_age: 5}
                        });
                        return;
                    }
                }

                // //unsetting any age variables set in builder
                // if(this.$root.builder.hasOwnProperty('min_age'))
                //     delete this.$root.builder.min_age;
                // if(this.$root.builder.hasOwnProperty('age'))
                //     delete this.$root.builder.age;

                // this.$router.push({
                //     name: !individual_days ? 'booking.weeks' : 'booking.packages',
                //     query: {
                //         days: !individual_days ? undefined : true
                //     }
                // });
            },
            update: function () {

                //Google analytics & Facebook Pixel scripts
                eval(this.$root.config.external_footer_scripts);

                /**
                 * Checking if there is a venue being set in the url params or
                 * there is already one set.
                 */
                if(this.$route.name.startsWith('booking.')) {
                    /**
                     * Setting the venue details on the builder
                     */
                    if (this.$route.params.hasOwnProperty('venueId')) {
                        axios.get('camp-booking/venues/' + this.$route.params.venueId)
                            .then(response => {
                                this.$root.builder.venue = response.data.data;
                                this.venue = this.$root.builder.venue;
                            })
                            .catch(e => {
                                window.location.replace(venues_change_url);
                            })
                    } else if (this.$root.builder != undefined) {
                        if(!this.$root.builder.hasOwnProperty('venue'))
                            window.location.replace(venues_change_url);
                        else
                            this.$router.push({ name: 'booking.age', params: { venueId: this.$root.builder.venue.id }})
                    } else {
                        window.location.replace(venues_change_url);
                    }

                    /**
                     * Setting the age details on the builder
                     */
                    if (this.$route.query.hasOwnProperty('age')) {
                        this.$root.builder.age = this.$route.query.age;
                    }

                }

                var shown_packages = ['booking.packages', 'booking.packages.customize', 'booking.weeks'];
                if(shown_packages.indexOf(this.$route.name) > -1) {
                    var d = new Date();
                    var day = d.getDay(),
                    diff = d.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
                    var first_day_of_week = new Date(d.setDate(diff));

                    var individual_days = this.$route.query.hasOwnProperty('days') && [true, "true", 1, "1"].includes(this.$route.query.days);
                    axios.get('camp-booking/packages', {
                        params: {
                            price_per: individual_days ? 'week' : 'day',
                            venue_id: this.$route.params.venueId,
                            min_start_date: (individual_days ? null : first_day_of_week.toISOString().split('T')[0]), //now.toISOString().split('.')[0] // JT: Causing dates that have already started to not show, shouldn't be required as long as venue_week_id is being provided
                            hide_internal: true
                        }
                    }).then(response => {
                        if(response.data.data.length > 0) {
                            this.show_switch_option = individual_days ? 'weeks' : 'days';
                        } else {
                            this.show_switch_option = false;
                        }
                    })
                } else {
                    this.show_switch_option = false;
                }
            },
            changeVenue: function () {
                window.location.href=venues_change_url;
            }
        },
        watch: {
            '$route': {
                handler (to) {
                    this.page = to.name;
                    this.builder = this.$root.builder;

                    this.update();
                    $("html, body").animate({ scrollTop: $("body").offset().top }, "slow");
                },
                deep: true
            },
        },
        created() {
            this.update();
        },
    }
</script>



// WEBPACK FOOTER //
// Header.vue?73613dbd